<router-outlet></router-outlet>

@if (loaderService.loading()) {
  <fbr-loader/>
}
